<div class="space-y-6">
  <!-- Page Header -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">{{ 'dashboard.title' | translate }}</h1>
      <p class="text-gray-600 mt-1">{{ 'dashboard.welcomeBack' | translate }}</p>
    </div>
    <div class="flex items-center space-x-3">
      <app-button variant="secondary">
        <svg class="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        {{ 'common.export' | translate }}
      </app-button>
      <app-button variant="primary">
        <svg class="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        {{ 'appointments.scheduleAppointment' | translate }}
      </app-button>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    <div class="stat-card bg-gradient-to-br from-blue-500 to-blue-600">
      <div class="flex items-center justify-between relative z-10">
        <div>
          <p class="text-blue-100 text-sm font-medium mb-1">{{ 'dashboard.totalPatients' | translate }}</p>
          <p class="text-3xl font-bold">{{ stats().totalPatients }}</p>
          <p class="text-blue-100 text-xs mt-2">
            <span class="inline-flex items-center">
              <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              +12% this month
            </span>
          </p>
        </div>
        <div class="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm">
          <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="stat-card bg-gradient-to-br from-green-500 to-green-600">
      <div class="flex items-center justify-between relative z-10">
        <div>
          <p class="text-green-100 text-sm font-medium mb-1">{{ 'dashboard.todayAppointments' | translate }}</p>
          <p class="text-3xl font-bold">{{ stats().todayAppointments }}</p>
          <p class="text-green-100 text-xs mt-2">
            <span class="inline-flex items-center">
              <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              On schedule
            </span>
          </p>
        </div>
        <div class="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm">
          <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="stat-card bg-gradient-to-br from-amber-500 to-amber-600">
      <div class="flex items-center justify-between relative z-10">
        <div>
          <p class="text-amber-100 text-sm font-medium mb-1">{{ 'dashboard.pendingBills' | translate }}</p>
          <p class="text-3xl font-bold">{{ stats().pendingBills }}</p>
          <p class="text-amber-100 text-xs mt-2">Requires attention</p>
        </div>
        <div class="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm">
          <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-5m-5 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="stat-card bg-gradient-to-br from-purple-500 to-purple-600">
      <div class="flex items-center justify-between relative z-10">
        <div>
          <p class="text-purple-100 text-sm font-medium mb-1">{{ 'dashboard.totalRevenue' | translate }}</p>
          <p class="text-3xl font-bold">${{ stats().totalRevenue.toLocaleString() }}</p>
          <p class="text-purple-100 text-xs mt-2">
            <span class="inline-flex items-center">
              <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              +8% from last month
            </span>
          </p>
        </div>
        <div class="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm">
          <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <!-- Upcoming Appointments -->
    <div class="lg:col-span-2 card">
      <div class="flex items-center justify-between mb-6">
        <div>
          <h3 class="text-lg font-semibold text-gray-900">{{ 'dashboard.todayAppointments' | translate }}</h3>
          <p class="text-sm text-gray-500 mt-1">{{ 'dashboard.manageQueue' | translate }}</p>
        </div>
        <a routerLink="/appointments" class="text-sm text-primary-600 hover:text-primary-700 font-medium">{{ 'dashboard.viewAll' | translate }} →</a>
      </div>
      <div class="space-y-3">
        @if (upcomingAppointments().length === 0) {
          <div class="text-center py-12">
            <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p class="text-gray-500">{{ 'dashboard.noAppointments' | translate }}</p>
          </div>
        } @else {
          @for (appointment of upcomingAppointments(); track appointment.id) {
            <div class="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-white rounded-xl border border-gray-200 hover:border-primary-300 transition-all duration-200">
              <div class="flex items-center space-x-4 flex-1">
                <div class="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-gray-900">{{ appointment.patientName }}</p>
                  <p class="text-sm text-gray-600">{{ appointment.type }} - {{ appointment.reason }}</p>
                  <p class="text-xs text-gray-500 mt-1">
                    <svg class="w-3 h-3 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {{ appointment.date | date:'short' }} at {{ appointment.time }}
                  </p>
                </div>
              </div>
              <div class="flex items-center space-x-3">
                <span class="badge"
                      [ngClass]="{
                        'badge-primary': appointment.status === 'Scheduled',
                        'badge-success': appointment.status === 'Confirmed',
                        'badge-warning': appointment.status === 'In Progress',
                        'badge-info': appointment.status === 'Completed'
                      }">
                  {{ appointment.status }}
                </span>
              </div>
            </div>
          }
        }
      </div>
    </div>

    <!-- Quick Actions & Recent Patients -->
    <div class="space-y-6">
      <!-- Quick Actions -->
      <div class="card">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ 'dashboard.quickActions' | translate }}</h3>
        <div class="space-y-2">
          <button class="w-full btn-secondary text-left justify-start">
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            {{ 'patients.addPatient' | translate }}
          </button>
          <button class="w-full btn-secondary text-left justify-start">
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            {{ 'medical-records.addRecord' | translate }}
          </button>
          <button class="w-full btn-secondary text-left justify-start">
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
            {{ 'prescriptions.addPrescription' | translate }}
          </button>
        </div>
      </div>

      <!-- Recent Patients -->
      <div class="card">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-gray-900">{{ 'dashboard.recentPatients' | translate }}</h3>
          <a routerLink="/patients" class="text-sm text-primary-600 hover:text-primary-700">{{ 'dashboard.viewAll' | translate }}</a>
        </div>
        <div class="space-y-3">
          @if (recentPatients().length === 0) {
            <p class="text-gray-500 text-center py-8 text-sm">{{ 'dashboard.noRecentPatients' | translate }}</p>
          } @else {
            @for (patient of recentPatients(); track patient.id) {
              <div class="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <div class="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center text-white font-semibold shadow-sm">
                  {{ patient.firstName.charAt(0) }}{{ patient.lastName.charAt(0) }}
                </div>
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 text-sm truncate">{{ patient.firstName }} {{ patient.lastName }}</p>
                  <p class="text-xs text-gray-500 truncate">{{ patient.email }}</p>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
